import React, { useEffect, useState } from 'react';
import { Autocomplete, TextField, CircularProgress } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { RejectReasonDto } from '../../../models/medicalCheckups/rejectReasonDto';
import { medicalCheckupsService } from '../../../services/medicalCheckupsService';

interface RejectReasonsAutocompleteFormControlProps {
  name: string;
  label?: string;
  style?: React.CSSProperties;
  required?: boolean;
}

const RejectReasonsAutocompleteFormControl: React.FC<RejectReasonsAutocompleteFormControlProps> = ({ name, label = 'Отклонения', style, required }) => {
  const { control } = useFormContext();
  const [rejectReasons, setRejectReasons] = useState<RejectReasonDto[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    medicalCheckupsService.getRejectReasons()
      .then(r => setRejectReasons(r.data.data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Controller
      name={name}
      control={control}
      rules={{ required: required ? 'Обязательное поле' : false }}
      render={({ field, fieldState }) => (
        <Autocomplete
          multiple
          options={rejectReasons}
          getOptionLabel={option => option.name}
          groupBy={option => option.group}
          value={field.value}
          onChange={(_, value) => {
            field.onChange(value)
          }}
          isOptionEqualToValue={(option, value) =>
            option.id === value.id
          }
          renderInput={params => (
            <TextField
              {...params}
              label={label}
              variant="outlined"
              margin="dense"
              size="small"
              style={style}
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
              required={required}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {loading ? <CircularProgress color="inherit" size={20} /> : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
          size="small"
          loading={loading}
        />
      )}
    />
  );
};

export default RejectReasonsAutocompleteFormControl; 